import React from "react";
import { ManageApproval } from "../../../containers";

const Approval = (props) => {
  return <ManageApproval {...props} />;
};

export default Approval;
